var map = {
	"./app/reducers/language.js": 18842,
	"./component/empty/language.js": 48048,
	"./component/footer/language.js": 34912,
	"./component/header/language.js": 52450,
	"./component/notice/language.js": 4745,
	"./component/product/language.js": 19658,
	"./component/supplier/language.js": 20349,
	"./component/uploadComponent/language.js": 78923,
	"./pages/allocations/components/allocationDashboard/language.js": 31273,
	"./pages/allocations/components/allocationMarket/language.js": 41479,
	"./pages/allocations/components/allocationSuggest/language.js": 25259,
	"./pages/allocations/components/allocationsBase/language.js": 77429,
	"./pages/allocations/components/allocationsCenter/language.js": 93669,
	"./pages/allocations/language.js": 72375,
	"./pages/apply/language.js": 27586,
	"./pages/buyers/language.js": 79690,
	"./pages/cart/language.js": 560,
	"./pages/company/address/components/language.js": 88481,
	"./pages/company/address/language.js": 578,
	"./pages/company/aptitude/language.js": 64900,
	"./pages/company/category​/index/language.js": 76280,
	"./pages/company/change/language.js": 80414,
	"./pages/company/delivery/language.js": 42010,
	"./pages/company/detail/language.js": 45985,
	"./pages/company/index/language.js": 96662,
	"./pages/documents/components/Print/language.js": 65599,
	"./pages/documents/purchase/language.js": 51438,
	"./pages/documents/supplier/language.js": 49675,
	"./pages/favorites/language.js": 79453,
	"./pages/home/components/classify/center/language.js": 20165,
	"./pages/home/components/classify/left/language.js": 72125,
	"./pages/home/components/classify/right/language.js": 72688,
	"./pages/home/components/newProducts/language.js": 62869,
	"./pages/home/components/purchaseSchool/language.js": 12948,
	"./pages/home/components/recommendProducts/language.js": 73273,
	"./pages/home/components/recommendProductsItem/language.js": 18652,
	"./pages/home/components/searchInput/language.js": 23139,
	"./pages/home/index/language.js": 44842,
	"./pages/invitePro/language.js": 97234,
	"./pages/login/language.js": 68325,
	"./pages/logistics/language.js": 6803,
	"./pages/notice/language.js": 43258,
	"./pages/order/language.js": 11874,
	"./pages/plan/language.js": 40535,
	"./pages/product/language.js": 37223,
	"./pages/quote/main/language.js": 12370,
	"./pages/register/language.js": 66937,
	"./pages/registerResult/language.js": 27930,
	"./pages/retrieve/language.js": 99514,
	"./pages/role/components/roleInfo/language.js": 80064,
	"./pages/role/index/language.js": 10203,
	"./pages/school/detail/language.js": 11162,
	"./pages/school/list/language.js": 7337,
	"./pages/search/language.js": 73450,
	"./pages/sourcing/language.js": 99640,
	"./pages/sourcing/main/language.js": 76984,
	"./pages/staff/components/linkModal/language.js": 46785,
	"./pages/staff/components/resetPassword/language.js": 36200,
	"./pages/staff/components/staffInfo/language.js": 59036,
	"./pages/staff/examine/language.js": 60080,
	"./pages/staff/index/language.js": 12393,
	"./pages/staff/link/language.js": 68039,
	"./pages/supplierApply/language.js": 19210,
	"./pages/supplierCenter/language.js": 19541,
	"./pages/supplierKpi/language.js": 73944,
	"./pages/supplierManage/language.js": 99031,
	"./pages/supplierVerify/language.js": 14953,
	"app/reducers/language.js": 18842,
	"component/empty/language.js": 48048,
	"component/footer/language.js": 34912,
	"component/header/language.js": 52450,
	"component/notice/language.js": 4745,
	"component/product/language.js": 19658,
	"component/supplier/language.js": 20349,
	"component/uploadComponent/language.js": 78923,
	"pages/allocations/components/allocationDashboard/language.js": 31273,
	"pages/allocations/components/allocationMarket/language.js": 41479,
	"pages/allocations/components/allocationSuggest/language.js": 25259,
	"pages/allocations/components/allocationsBase/language.js": 77429,
	"pages/allocations/components/allocationsCenter/language.js": 93669,
	"pages/allocations/language.js": 72375,
	"pages/apply/language.js": 27586,
	"pages/buyers/language.js": 79690,
	"pages/cart/language.js": 560,
	"pages/company/address/components/language.js": 88481,
	"pages/company/address/language.js": 578,
	"pages/company/aptitude/language.js": 64900,
	"pages/company/category​/index/language.js": 76280,
	"pages/company/change/language.js": 80414,
	"pages/company/delivery/language.js": 42010,
	"pages/company/detail/language.js": 45985,
	"pages/company/index/language.js": 96662,
	"pages/documents/components/Print/language.js": 65599,
	"pages/documents/purchase/language.js": 51438,
	"pages/documents/supplier/language.js": 49675,
	"pages/favorites/language.js": 79453,
	"pages/home/components/classify/center/language.js": 20165,
	"pages/home/components/classify/left/language.js": 72125,
	"pages/home/components/classify/right/language.js": 72688,
	"pages/home/components/newProducts/language.js": 62869,
	"pages/home/components/purchaseSchool/language.js": 12948,
	"pages/home/components/recommendProducts/language.js": 73273,
	"pages/home/components/recommendProductsItem/language.js": 18652,
	"pages/home/components/searchInput/language.js": 23139,
	"pages/home/index/language.js": 44842,
	"pages/invitePro/language.js": 97234,
	"pages/login/language.js": 68325,
	"pages/logistics/language.js": 6803,
	"pages/notice/language.js": 43258,
	"pages/order/language.js": 11874,
	"pages/plan/language.js": 40535,
	"pages/product/language.js": 37223,
	"pages/quote/main/language.js": 12370,
	"pages/register/language.js": 66937,
	"pages/registerResult/language.js": 27930,
	"pages/retrieve/language.js": 99514,
	"pages/role/components/roleInfo/language.js": 80064,
	"pages/role/index/language.js": 10203,
	"pages/school/detail/language.js": 11162,
	"pages/school/list/language.js": 7337,
	"pages/search/language.js": 73450,
	"pages/sourcing/language.js": 99640,
	"pages/sourcing/main/language.js": 76984,
	"pages/staff/components/linkModal/language.js": 46785,
	"pages/staff/components/resetPassword/language.js": 36200,
	"pages/staff/components/staffInfo/language.js": 59036,
	"pages/staff/examine/language.js": 60080,
	"pages/staff/index/language.js": 12393,
	"pages/staff/link/language.js": 68039,
	"pages/supplierApply/language.js": 19210,
	"pages/supplierCenter/language.js": 19541,
	"pages/supplierKpi/language.js": 73944,
	"pages/supplierManage/language.js": 99031,
	"pages/supplierVerify/language.js": 14953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41336;